(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ohs-player-reference-app"] = factory();
	else
		root["ohs-player-reference-app"] = factory();
})(globalThis, () => {
return 